import React, { useState } from "react";
import { useEnquiryModal } from "./EnquiryModal";

const data = {
  dubai: {
    apartments: [
      { text: "Apartments for sale in Dubai"},
      { text: "Apartments for sale in Downtown Dubai"},
      { text: "Apartments for sale in Jumeirah Village Circle"},
      { text: "Apartments for sale in Dubai Marina"},
      { text: "Apartments for sale in Dubai Creek Harbour"},
    ],
    villas: [
      { text: "Villas for sale in Dubai"},
      { text: "Villas for sale in Palm Jumeirah"},
      { text: "Villas for sale in Dubai Hills Estate"},
      { text: "Villas for sale in DAMAC Hills 2 (Akoya by DAMAC)"},
      { text: "Villas for sale in Al Furjan"},
      { text: "Villas for sale in Arabian Ranches"},
      { text: "Villas for sale in The Meadows"},
    ],
    other: [
      { text: "Properties for sale in Dubai"},
      { text: "Townhouses for sale in Dubai"},
      { text: "Penthouses for sale in Dubai"},
      { text: "Hotel Apartments for sale in Dubai"},
      { text: "Residential Plots for sale in Dubai"},
      { text: "Commercial Properties for sale in Dubai"},
      { text: "Off Plan Projects in Dubai"},
    ],
  },
  abuDhabi: {
    apartments: [
      { text: "Apartments for sale in Dubai"},
      { text: "Apartments for sale in Downtown Dubai"},
      { text: "Apartments for sale in Jumeirah Village Circle"},
      { text: "Apartments for sale in Dubai Marina"},
      { text: "Apartments for sale in Business Bay"},
      { text: "Apartments for sale in Jumeirah Beach Residence (JBR)"},
      { text: "Apartments for sale in Dubai Creek Harbour"},
    ],
    villas: [
      { text: "Villas for sale in Dubai"},
      { text: "Villas for sale in Palm Jumeirah"},
      { text: "Villas for sale in Dubai Hills Estate"},
      { text: "Villas for sale in Al Furjan"},
      { text: "Villas for sale in Arabian Ranches"},
      { text: "Villas for sale in The Meadows"},
    ],
    other: [
      { text: "Properties for sale in Dubai"},
      { text: "Townhouses for sale in Dubai"},
      { text: "Hotel Apartments for sale in Dubai"},
      { text: "Residential Plots for sale in Dubai"},
      { text: "Commercial Properties for sale in Dubai"},
      { text: "Off Plan Projects in Dubai"},
    ],
  },
  otherEmirates: {
    apartments: [
      { text: "Apartments for sale in Dubai"},
      { text: "Apartments for sale in Downtown Dubai"},
      { text: "Apartments for sale in Jumeirah Village Circle"},
      { text: "Apartments for sale in Dubai Marina"},
      { text: "Apartments for sale in Business Bay"},
      { text: "Apartments for sale in Dubai Creek Harbour"},
    ],
    villas: [
      { text: "Villas for sale in Dubai"},
      { text: "Villas for sale in Palm Jumeirah"},
      { text: "Villas for sale in Dubai Hills Estate"},
      { text: "Villas for sale in Al Furjan"},
      { text: "Villas for sale in Arabian Ranches"},
      { text: "Villas for sale in The Meadows"},
    ],
    other: [
      { text: "Properties for sale in Dubai"},
      { text: "Townhouses for sale in Dubai"},
      { text: "Penthouses for sale in Dubai"},
      { text: "Hotel Apartments for sale in Dubai"},
      { text: "Residential Plots for sale in Dubai"},
      { text: "Commercial Properties for sale in Dubai"},
      { text: "Off Plan Projects in Dubai"},
    ],
  },
};

export default function PopularSearches() {
  const [activeTab, setActiveTab] = useState("sale");
  const [activeCity, setActiveCity] = useState("dubai");
  const [showMore, setShowMore] = useState(false);
  const { openModal } = useEnquiryModal();

  const renderLinks = (title, links) => {
    const visibleLinks = showMore ? links : links.slice(0, 5);
    return (
      <div className="flex-1 mb-8 md:mb-0">
        <h3 className="font-semibold text-[#000000] mb-3 uppercase text-lg tracking-wide">{title}</h3>
        <ul className="space-y-1 transition-all duration-300">
          {visibleLinks.map((item, index) => (
            <li key={index}>
              <a href={item.href} className="text-[#003153] hover:underline text-md md:text-base">
                {item.text}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  // Map city buttons to data keys
  const cityMap = {
    Dubai: "dubai",
    "Abu Dhabi": "abuDhabi",
    "Other Emirates": "otherEmirates",
  };

  return (
    <section className="max-w-7xl mx-auto py-6 sm:py-10 px-4 md:px-12">
      <h2 className="text-center text-3xl md:text-4xl font-semibold text-[#003153] mb-8">Popular Real Estate Searches</h2>

      {/* Tabs */}
      <div className="flex justify-center space-x-8 mb-6 border-b border-gray-300">
        {["Sale", "Rent"].map((tab) => (
          <button
            key={tab}
            className={`pb-2 text-lg font-medium ${
              activeTab === tab.toLowerCase() ? "text-[#003153] border-b-2 border-[#003153]" : "text-gray-500"
            }`}
            onClick={() => setActiveTab(tab.toLowerCase())}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* City Buttons */}
      <div className="flex justify-center flex-wrap gap-3 mb-8">
        {Object.keys(cityMap).map((city) => (
          <button
            key={city}
            className={`px-4 py-2 font-semibold rounded-md border text-md md:text-base transition-all ${
              activeCity === cityMap[city] ? "bg-[#003153]/10 text-[#003153] border-[#003153]" : "border-gray-300 text-gray-600 hover:border-[#003153]"
            }`}
            onClick={() => setActiveCity(cityMap[city])}
          >
            {city}
          </button>
        ))}
      </div>

      <div className="text-center text-lg font-semibold text-black mb-6">
        All {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}
      </div>

      {/* Links Section */}
      <div onClick={openModal} className="flex flex-col md:flex-row md:space-x-10">
        {renderLinks("Apartments", data[activeCity]?.apartments || [])}
        {renderLinks("Villas", data[activeCity]?.villas || [])}
        {renderLinks("Other Properties", data[activeCity]?.other || [])}
      </div>

      {/* View More Button */}
      <div className="text-center mt-8">
        <button
          onClick={() => setShowMore(!showMore)}
          className="text-[#003153] text-md md:text-base font-medium hover:underline"
        >
          {showMore ? "View Less ↑" : "View More ↓"}
        </button>
      </div>
    </section>
  );
}
